module.exports = __webpack_public_path__ + "img/1.06540772.png";